// careful: also used in sas-scorm
export enum GenericProgressStatus {
  NOT_STARTED = 'not-started',
  STARTED = 'started',
  COMPLETE = 'complete',
  LOCKED = 'locked',
  FAILED = 'failed',
}
export enum ScoreFindStrategy {
  BEST_SCORE = 'best-score',
  LAST = 'last',
  FIRST = 'first',
}

export enum HistoryEntryType {
  INTERACTIVITY_DONE = 'interactivity-done',
  GAME = 'game',
  FILE_DOWNLOAD = 'file-download',
  VIDEO = 'video',
  PODCAST = 'podcast',
  LINK = 'link',
  SCORM = 'scorm',
  CLASSIZ = 'classiz',
}

export enum GenericProgressScormStatus {
  NOT_STARTED = 'n',
  STARTED = 's',
  COMPLETE = 'c',
  LOCKED = 'l',
  FAILED = 'f',
}
